let Captcha = {
  initCaptcha: function(){
    $.ajax({
      type: 'POST',
      url: '/api/form.resume/?a=captcha',
      data: '',
      dataType: 'json',
      success: function(data) {
        if (data.success) {
            $('[data-img-captcha]').append('<img src="' + data.captcha_img + '" alt="" />');
            $('[data-hidden-input-captcha]').val(data.captcha_code);
        } else {
            console.error(data);
        }
      },
      error:  function(xhr, str){
        //alert('Возникла ошибка: ' + xhr.responseCode);
      }
    });
  }
}

export default {
  initCaptcha: Captcha.initCaptcha
};



// WEBPACK FOOTER //
// ./components/captcha.js